module.exports = __webpack_public_path__ + "static/img/3041_phase_function_Paper_PointsHejduk_Prediction.55f7570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3041_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 8MS4
// module chunks = 0